import { useState } from "react";
import { Box, Card, Typography, Skeleton, Grid, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import LoadingAnimation from "../Animations/LoadingAnimation";
import { headingFonts, noOutline } from "../../Styles/Styles";

const ImageWithSkeleton = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && (
        <Skeleton
          variant="circular"
          width={80}
          height={80}
          animation="wave"
          sx={{ position: "absolute" }}
        />
      )}
      <img
        src={src}
        alt={alt}
        style={{
          height: 90,
          display: loaded ? "block" : "none",
        }}
        onLoad={() => setLoaded(true)}
      />
    </>
  );
};

const Categories = ({ categories, isLoadingCategories, categoriesError }) => {
  if (isLoadingCategories) {
    return <LoadingAnimation />;
  }

  if (categoriesError) {
    return (
      <Box sx={{ textAlign: "center", mt: 5 }}>
        <Typography variant="body1" color="error">
          Failed to load categories. Please try again.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ margin: "auto", mt: 5, px: 2, width: "95%" }}>
      <Grid container spacing={3} justifyContent="center" alignItems="stretch">
        {categories.map((category, index) => (
          <Grid item key={index} xs={6} sm={4} md={2} lg={2}>
            <Card
              sx={{
                padding: "20px",
                mt: 8,
                textAlign: "center",
                position: "relative",
                overflow: "visible",
                transition: "all 0.3s ease-in-out",
                border: "1px solid #ddd",
                boxShadow: "none",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                "&:hover": {
                  border: "1px solid var(--primary-color)",
                  "& img": {
                    filter: "brightness(0.8)",
                  },
                  "& .category-title": {
                    color: "var(--primary-color)",
                  },
                  "& .circle-button": {
                    border: "1px solid var(--primary-color)",
                    backgroundColor: "white",
                  },
                },
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 80,
                  height: 80,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  color: "#fff",
                }}
              >
                {/* <img
                  src={category.image}
                  alt={category.label}
                  style={{ height: 90 }}
                /> */}
                <ImageWithSkeleton src={category.image} alt={category.label} />
              </Box>

              <Typography
                variant="body1"
                className="category-title"
                sx={{
                  ...headingFonts,
                  mt: 3,
                  mb: 4,
                  textDecoration: "none", // Remove default underline
                  "&:hover": {
                    color: "var(--primary-color)", // Change color on hover
                  },
                }}
              >
                <Link
                  to={category.slug}
                  style={{
                    textDecoration: "none",
                    color: "inherit", // Inherit text color from parent
                  }}
                >
                  {category.label}
                </Link>
              </Typography>

              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: "50%",
                  transform: "translate(-50%, 50%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Link to={category.slug}>
                  <Button
                    variant="outlined"
                    className="circle-button"
                    sx={{
                      borderRadius: "50%",
                      minWidth: "40px",
                      width: "50px",
                      height: "50px",
                      border: "1px solid #ddd",
                      color: "var(--primary-color)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "white",
                      ...noOutline,
                    }}
                  >
                    <ArrowForwardIcon />
                  </Button>
                </Link>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Categories;
